import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { useAuth } from "vue-auth3";
import { emitter, MittType } from "./plugins/event-bus";
import { RoleCode } from "./plugins/auth/roles";

function loadView(view: string) {
  return () => import(`./pages/${view}.vue`);
}

const routes: Array<RouteRecordRaw> = [
  {
    path: "/user",
    name: "Пользователи",
    component: loadView("users/Index"),
    meta: {
      auth: [RoleCode.ADMINISTRATION_READ_INTERNAL],
      title: "Пользователи",
      group: "settings",
      icon: "user",
    },
  },
  {
    path: "/setting",
    name: "Настройки",
    component: loadView("settings/Index"),
    meta: {
      auth: [RoleCode.ADMINISTRATION_READ_INTERNAL],
      title: "Настройки",
      group: "settings",
      icon: "gear",
    },
  },
  {
    path: "/user-history",
    name: "Лог действий пользователя",
    component: loadView("user-history/Index"),
    meta: {
      auth: [RoleCode.ADMINISTRATION_READ_INTERNAL],
      title: "Лог действий пользователя",
      group: "settings",
      icon: "history",
    },
  },
  {
    path: "/",
    name: "home",
    component: loadView("home/Index"),
    meta: {
      hasMenu: false,
      title: "Выберите раздел",
      hidden: true,
    },
  },
  {
    path: "/sly-shopping",
    name: "Гарантированная скидка на покупку",
    component: loadView("sly-shopping/SlyShoppingIndex"),
    meta: {
      auth: [RoleCode.SLY_SHOPPING_READ],
      group: "sly-shopping",
      icon: "cart-shopping",
      title: "Гарантированная скидка на покупку",
    },
  },
  {
    path: "/three-coupons",
    name: "3 Купона",
    component: loadView("sly-shopping/ThreeCouponsIndex"),
    meta: {
      auth: [RoleCode.SLY_SHOPPING_WRITE_INTERNAL],
      group: "sly-shopping",
      icon: "ticket-simple",
      title: "3 Купона",
    },
  },
  {
    path: "/sly-shopping-waves",
    name: "Волны гарантированной скидки",
    component: loadView("sly-shopping/SlyShoppingAdminIndex"),
    meta: {
      auth: [RoleCode.SLY_SHOPPING_WRITE_INTERNAL],
      group: "sly-shopping",
      icon: "list",
      title: "Волны гарантированной скидки",
    },
  },
  {
    path: "/product",
    name: "Поиск товара",
    component: loadView("products/Index"),
    meta: {
      auth: [RoleCode.PRODUCTS_READ],
      hidden: true,
      hasMenu: false,
      title: "Поиск товара",
      icon: "boxes-packing",
    },
  },
  {
    path: "/calls",
    name: "Обзвоны",
    component: loadView("calls/Index"),
    meta: {
      auth: [RoleCode.CALLS_WRITE_INTERNAL],
      group: "calls",
      title: "Обзвоны",
      icon: "headset",
    },
  },
  {
    path: "/calls-search",
    name: "Поиск клиента в обзвонах",
    component: loadView("calls-search/Index"),
    meta: {
      auth: [RoleCode.CALLS_WRITE_INTERNAL],
      group: "calls",
      title: "Поиск клиента в обзвонах",
      icon: "magnifying-glass",
    },
  },
  {
    path: "/clients",
    name: "Поиск клиента",
    component: loadView("clients/Index"),
    meta: {
      auth: [RoleCode.CLIENTS_READ],
      hidden: true,
      hasMenu: false,
      title: "Поиск клиента",
      icon: "users",
      cacheComponent: true,
    },
  },
  {
    path: "/clients/:store_key/:cust_no",
    name: "Информация по клиенту",
    component: loadView("clients/CustDetails"),
    meta: {
      auth: [RoleCode.CLIENTS_READ],
      hidden: true,
      hasMenu: false,
      title: "Информация по клиенту",
      icon: "users",
      cacheComponent: true,
    },
    props: true,
  },
  {
    path: "/file-storage",
    name: "Файловое хранилище",
    component: loadView("file-storage/Index"),
    meta: {
      auth: [RoleCode.FILE_STORAGE_READ],
      hasMenu: false,
      title: "Файловое хранилище",
      hidden: true,
    },
  },
  {
    path: "/m-shop",
    name: "M|SHOP bot",
    component: loadView("m-shop/Index"),
    meta: {
      auth: [RoleCode.M_SHOP_READ_INTERNAL],
      title: "M|SHOP bot",
    },
  },
  {
    path: "/base",
    name: "Базы",
    component: loadView("base/Index"),
    meta: {
      auth: [RoleCode.BASE_READ],
      group: "bases",
      title: "Базы",
      icon: "table",
    },
  },
  {
    path: "/base-archive",
    name: "Архив",
    component: loadView("base/Archive"),
    meta: {
      auth: [RoleCode.BASE_WRITE_INTERNAL],
      group: "bases",
      title: "Базы - Архив",
      icon: "folder-open",
    },
  },
  {
    path: "/crm-mechanics-add",
    name: "Добавить кампанию",
    component: loadView("crm-mechanics/Index"),
    meta: {
      auth: [RoleCode.CRM_MECHANICS_WRITE_INTERNAL],
      group: "crm-mechanics",
      title: "Добавить кампанию",
      icon: "circle-dollar-to-slot",
    },
  },
  {
    path: "/crm-mechanics-search",
    name: "Запросить результат",
    component: loadView("crm-mechanics/Search"),
    meta: {
      auth: [RoleCode.CRM_MECHANICS_WRITE_INTERNAL],
      group: "crm-mechanics",
      title: "Запросить результат",
      icon: "magnifying-glass",
    },
  },
  /*---------------------------------------------------------------------*/
  {
    path: "/login",
    name: "login",
    component: loadView("auth/Login"),
    meta: {
      auth: false,
      title: "Вход в систему",
      hideLayout: true,
      hidden: true,
    },
  },
  {
    path: "/403",
    name: "403",
    component: loadView("errors/403"),
    meta: {
      title: "Ошибка 403",
      hidden: true,
      hasMenu: false,
    },
  },
  {
    path: "/:catchAll(.*)",
    name: "404",
    component: loadView("errors/404"),
    meta: {
      auth: true,
      title: "Ошибка 404",
      hidden: true,
      hasMenu: false,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  emitter.emit(MittType.autofocus);
  sessionStorage.setItem("redirectPath", to.path == "/login" ? "/" : to.fullPath);
  const title = to.meta.title; //TODO mborodin: можно добавлять данные из параметров to.params.<название параметра>
  if (title) {
    document.title = "METRO - " + (title as string);
  } else {
    document.title = "METRO";
  }
  next();
});

export default router;

export function getAvailableRoutes() {
  const allRouters = router.getRoutes();
  const auth = useAuth();
  const routes = allRouters.filter(
    (r) =>
      r.meta.hidden != true &&
      (r.meta.auth == undefined ||
        r.meta.auth == auth.check() ||
        (["string", "object"].includes(typeof r.meta.auth) && auth.check(r.meta.auth as string | string[])))
  );
  return routes;
}
